import moment from 'moment/moment';
import { Set } from 'immutable';
import { PAYMENT_STATUSES, PAYMENT_TAGS } from 'domain/payments/constants';
import type { PaymentInfoRecord } from 'domain/payments/types';

export const canStartPaymentApprovalFlow = (paymentInfo: PaymentInfoRecord): boolean =>
  paymentInfo.status === PAYMENT_STATUSES.PREPARATION &&
  Boolean(paymentInfo.payFrom) &&
  Boolean(paymentInfo.payTo) &&
  !moment(paymentInfo.paymentDate).isBefore(moment(), 'day');

export const canStartPaymentProcess = (paymentTags: Set<string>): boolean =>
  paymentTags.has(PAYMENT_TAGS.saveForLater);

export const canArchivePayment = (status: string): boolean =>
  ([
    PAYMENT_STATUSES.PENDING_APPROVAL,
    PAYMENT_STATUSES.APPROVED,
    PAYMENT_STATUSES.APPROVAL_REJECTED,
    PAYMENT_STATUSES.PROCESSING,
    PAYMENT_STATUSES.PROCESSING_VOID,
  ] as string[]).includes(status);
